export const hosts = [
  {
    id: 1,
    name: "박민지",
    title: "텐진 지역 슈퍼호스트",
    since: "2019",
    yearsInFukuoka: 7,
    languages: ["한국어", "일본어", "영어"],
    specialty: "맛집 예약 대행 & 관광 코스 추천",
    bio: "안녕하세요! 후쿠오카에 산 지 7년째인 박민지예요. 텐진 구석구석 모르는 곳이 없답니다. 라멘집 웨이팅 없이 들어가는 비법부터 현지인만 아는 야타이(포장마차) 위치까지, 카카오톡으로 실시간 도움 드려요!",
    helps: ["맛집 웨이팅 없이 예약", "긴급 통역 지원", "공항 교통 안내"],
    image: "https://public.readdy.ai/ai/img_res/5abe0912e1f4509a2727a470b0621ecb.jpg",
    reviews: 142,
    rating: 4.98,
  },
  {
    id: 2,
    name: "김서연",
    title: "하카타 가족여행 전문 호스트",
    since: "2020",
    yearsInFukuoka: 9,
    languages: ["한국어", "일본어"],
    specialty: "가족 여행 코디 & 아이 동반 맛집",
    bio: "두 아이를 키우는 엄마로서, 아이와 함께하는 여행의 어려움을 너무 잘 알아요. 유아 용품 대여부터 아이가 좋아하는 음식점 예약까지, 엄마의 마음으로 도와드릴게요. 가족 여행은 저한테 맡겨주세요!",
    helps: ["유아용품 무료 대여", "가족 맛집 예약 대행", "아이 놀거리 코스 추천"],
    image: "https://readdy.ai/api/search-image?query=Studio%20Ghibli%20style%20anime%20illustration%20portrait%20of%20a%20gentle%20warm%20woman%20with%20long%20wavy%20brown%20hair%20soft%20kind%20eyes%20wearing%20light%20blue%20floral%20dress%20holding%20small%20flower%20gentle%20motherly%20expression%20soft%20mint%20green%20and%20sky%20blue%20watercolor%20background%20Miyazaki%20hand%20drawn%20animation%20style&width=400&height=400&seq=302&orientation=squarish",
    reviews: 89,
    rating: 4.96,
  },
  {
    id: 3,
    name: "이준호",
    title: "나카스 야경 맛집 가이드",
    since: "2021",
    yearsInFukuoka: 5,
    languages: ["한국어", "일본어", "중국어"],
    specialty: "야타이 문화 & 나카스 나이트라이프",
    bio: "나카스 강변에 살면서 매일 밤 아름다운 야경을 봐요. 후쿠오카의 밤 문화, 야타이(포장마차) 투어, 현지 맥주 바까지 안내해 드립니다. 일본어 못하셔도 걱정 마세요, 제가 옆에 있으니까요!",
    helps: ["야타이 투어 동행", "네온 야경 포인트 안내", "응급 상황 24시간 지원"],
    image: "https://readdy.ai/api/search-image?query=Studio%20Ghibli%20style%20anime%20illustration%20portrait%20of%20a%20cheerful%20young%20man%20with%20tousled%20dark%20hair%20casual%20olive%20green%20jacket%20confident%20friendly%20grin%20warm%20amber%20and%20golden%20night%20sky%20watercolor%20background%20Miyazaki%20hand%20drawn%20cel%20animation%20style%20expressive%20lively%20face&width=400&height=400&seq=303&orientation=squarish",
    reviews: 201,
    rating: 4.99,
  },
];
